module.exports = __webpack_public_path__ + "img/profile_bold.724e53eb.svg";